import React from "react";

const ImeiProductModalInfo = ({
  product_img,
  imeiList,
  toggleImeiSelection,
  barcodeImei,
  selectedImeis,
  setOpen
}) => {
  return (
    <div className="relative">
      <img src={product_img} />
      <div className="mb-2">
        <div className="flex justify-between">
          <div></div>
          <p className="font-semibold mr-10">Price</p>
          <p className="font-semibold ">Imei</p>
        </div>
        <hr />

        {imeiList.length &&
          imeiList.map((imei, idx) => {
            return (
              <div
                key={imei.id}
                className="flex  justify-between items-center mt-3 border-b"
              >

                  <input
                    key={imei.id}
                    checked={
                      selectedImeis.includes(imei.id) ||
                      barcodeImei === imei.imei
                    }
                    onChange={() => toggleImeiSelection(imei)}
                    type="checkbox"
                    name={imei.imei}
                    id={imei.imei}
                    className="mr-2"
                  />
                  <p>{imei.sale_price}</p>
                <div>
                  <label for={imei.imei} className="font-semibold">
                    {imei.imei}
                  </label>
                </div>
              </div>
            );
          })}
      </div>
      <div className="sticky mt-5 bottom-0 w-full">
          <button
            htmlFor="my_modal_payment"
            onClick={() => setOpen(false)}
            className="cursor-pointer w-full bg-[#3559b3] hover:bg-[#034AFF] py-[17px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg"
          >
            Save
          </button>
        </div>
    </div>
  );
};

export default ImeiProductModalInfo;
